module.exports = __webpack_public_path__ + "static/media/img149.8de3d685.jpg";